const Routes = {
    HOME_PAGE: '/app/home',
    SETTINGS_PAGE: '/app/settings',
    AUTH_PAGE: '/auth'
};

export default Routes;
